import { useContext, useState } from "react";
import ModalSys from "../modal";
import { Grid, Typography } from "@mui/material";
import CardSys from "../cardSys";
import ButtonOk from "../buttonOk";
import ButtonConsultLogs from "../buttonConsultLog";
import { useNavigate } from "react-router-dom";
import { GlobalAlertContext } from "../../contexts/GlobalAlertContext";
import { api } from "../../services/api";

export default function SyncError({ handleClose }) {
  const [modal, setModal] = useState(false);
  const navigate = useNavigate();
  const { handleToast, handleLoading } = useContext(GlobalAlertContext);

  async function syncManual() {
    handleLoading(true);
    try {
      const { data: syncManual } = await api({ method: "POST", url: "/sync/sync" });
    } catch (err) {
      handleToast(true, err.response.data.toast, err.response.data.message);
    }
    handleLoading(false);
  }

  return (
    <>
      <CardSys sx={{ display: "flex", justifyContent: "center" }}>
        <Grid container>
          <Typography sx={{ textAlign: "center", margin: "40px" }}>
            Erro na Sincronização
          </Typography>
        </Grid>
        <Grid sx={{ display: "flex", justifyContent: "center",gap:"20px" }}>
            <ButtonConsultLogs onClick={() => navigate("/logs")}></ButtonConsultLogs>
            <ButtonOk onClick={syncManual}>Tentar novamente</ButtonOk>
        </Grid>
      </CardSys>
    </>
  );
}
